<template>
	<div style="width: 100%; overflow-y: auto; padding-right: 20px" :style="{ height: height + 'px' }">
		<grid-layout
			:layout.sync="layout"
			style="z-index: 1"
			:col-num="12"
			:row-height="37"
			:is-draggable="true"
			:is-resizable="false"
			:responsive="true"
			:vertical-compact="false"
			:use-css-transforms="true"
		>
			<grid-item v-if="pwd_exp_days < 11" :i="12" :x="0" :y="0" :w="8" :h="3">
				<div class="card state md-elevation-4" style="background-color: #ff4d4d">
					<div style="padding: 10px">
						<span style="font-size: 24px; font-weight: 900; color: white">{{ $t("expiring-pwd") }}</span>
						<p style="font-size: 20px; margin-top: 10px; color: white">
							{{
								$t("expiring-pwd-text")
									.replace("%NUMBER%", pwd_exp_days)
									.replace("%DAY%", pwd_exp_days == 1 ? "giorno" : "giorni")
							}}
						</p>
					</div>
				</div>
			</grid-item>

			<grid-item
				v-for="(item, index) of layout"
				:key="index"
				style="z-index: 1"
				:x="item.x"
				:y="pwd_exp_days < 11 ? item.y + 3 : item.y"
				:w="item.w"
				:h="item.h"
				:i="item.i"
				:static="false"
			>
				<component v-bind:is="item.component" />
			</grid-item>
		</grid-layout>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { GridLayout, GridItem } from "vue-grid-layout"
import SubscriptionsCard from "./cards/subscriptions-card.vue"
import SchoolsCard from "./cards/schools-card.vue"
import UsersCard from "./cards/users-card.vue"
import DocumentsCard from "./cards/documents-card.vue"
import ActiveusersCard from "./cards/activeusers-card.vue"
import ActiveSubscriptionsCard from "./cards/activesubscriptions-card.vue"
import PaymentCard from "./cards/payment-card.vue"
import TicketsCard from "./cards/tickets-card.vue"

import ProfitChart from "./charts/profit-chart.vue"
import Calendar from "./charts/calendar-chart.vue"
import CounterChart from "./charts/counter-chart.vue"
import SubscriptionChart from "./charts/subscriptions-chart.vue"
import SchoolsChart from "./charts/schools-chart.vue"
import MovementsChart from "./charts/movements-chart.vue"
import CompilationsChart from "./charts/compilations-chart.vue"
import DocumentsChart from "./charts/documents-chart.vue"

import moment from "moment"

export default {
	name: "dashboard",
	components: {
		GridLayout,
		GridItem,

		SubscriptionsCard,
		SchoolsCard,
		UsersCard,
		DocumentsCard,
		ActiveusersCard,
		"activesubscriptions-card": ActiveSubscriptionsCard,
		Calendar,
		TicketsCard,

		ProfitChart,
		CounterChart,
		SubscriptionChart,
		SchoolsChart,
		PaymentCard,
		MovementsChart,
		CompilationsChart,
		DocumentsChart
	},
	data() {
		return {
			height: window.innerHeight - 90,
			layout: [
				{ component: "activeusers-card", x: 0, y: 0, w: 2, h: 3, i: "0" },
				{ component: "schools-card", x: 2, y: 0, w: 2, h: 3, i: "1" },
				{ component: "users-card", x: 4, y: 0, w: 2, h: 3, i: "2" },
				{ component: "activesubscriptions-card", x: 6, y: 0, w: 2, h: 3, i: "10" },
				{ component: "tickets-card", x: 8, y: 0, w: 2, h: 3, i: "11" },
				{ component: "payment-card", x: 10, y: 0, w: 2, h: 3, i: "3" },
				{ component: "profit-chart", x: 0, y: 3, w: 9, h: 10, i: "4" }, // TO DO: refactor
				{ component: "movements-chart", x: 9, y: 3, w: 3, h: 10, i: "5" },
				{ component: "subscription-chart", x: 0, y: 13, w: 9, h: 10, i: "6" },
				{ component: "calendar", x: 9, y: 13, w: 3, h: 10, i: "7" },
				{ component: "compilations-chart", x: 0, y: 23, w: 9, h: 10, i: "8" }, // TO DO: refactor
				{ component: "documents-chart", x: 9, y: 23, w: 3, h: 10, i: "9" } // TO DO: refactor
			],
			pwd_exp_days: 100
		}
	},
	computed: {
		...mapGetters({
			users: "dashboard/usersNumber",
			schools: "dashboard/schoolsNumber",
			subscriptions: "dashboard/subscriptions",
			payments: "dashboard/paymentsNumber",
			tickets: "dashboard/ticketsNumber",
			pwd_exp: "user/pwd_exp"
		})
	},
	methods: {
		...mapActions({
			doUsers: "dashboard/doUsers",
			doTickets: "dashboard/doTickets",
			doSchools: "dashboard/doSchools",
			doSubscriptions: "dashboard/doSubscriptions",
			doPayments: "dashboard/doPayments"
		}),
		itemTitle(item) {
			let result = item.i
			if (item.static) {
				result += " - Static"
			}
			return result
		}
	},

	async created() {
		if (this.users.all === undefined) this.doUsers()
		if (this.schools.all === undefined) this.doSchools()
		if (this.payments.active === undefined) this.doPayments()
		if (this.tickets.active === undefined) this.doTickets()

		if (this.pwd_exp) {
			var valid_until = moment(this.pwd_exp)
			var r = moment.duration(valid_until.diff(this.now))
			this.pwd_exp_days = Math.ceil(r.asDays())
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/chart.scss";

.count-card {
	padding: 10px;
	border-radius: 25px;
	width: 150px;
	margin: 5px;
	color: white;
	&:hover {
		cursor: pointer;
	}
}

.vue-grid-layout {
	background: #eee;
}

.vue-grid-item .resizing {
	opacity: 0.9;
}
.vue-grid-item .static {
	background: #cce;
}
.vue-grid-item .text {
	font-size: 24px;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	height: 100%;
	width: 100%;
}
.vue-grid-item .no-drag {
	height: 100%;
	width: 100%;
}
.vue-grid-item .minMax {
	font-size: 12px;
}
.vue-grid-item .add {
	cursor: pointer;
}
.vue-draggable-handle {
	position: absolute;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;

	background-position: bottom right;
	padding: 0 8px 8px 0;
	background-repeat: no-repeat;
	background-origin: content-box;
	box-sizing: border-box;
	cursor: pointer;
}
</style>
